import React, { Component } from 'react';
import { IoMdCheckmark } from 'react-icons/io';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import propTypes from 'prop-types';

export const CustomCheckBox = styled.div`
  margin-top: 20px;
  padding-bottom: 15px;
  position: relative;

  label {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 10px;
    text-align: left;
    cursor: pointer;
  }

  input {
    display: none;

    &:checked + .box svg {
      opacity: 1;
      transform: scale(1);
    }
  }

  .box {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: 1px solid #ccc;
    background: 0 0;
    border-radius: 4px;

    svg {
      position: absolute;
      top: 0;
      left: 1px;
      width: 18px;
      height: 18px;
      fill: #4d7cfe;
      opacity: 0;
      transform: scale(0);
      transition: all 0.2s;
    }
  }

  .terms {
    margin-left: 15px;
    font-size: 14px;
    line-height: 1.2;

    a {
      margin-right: 4px;
    }
  }
`;

const ErrorMessage = styled.span`
  display: block;
  width: 100%;
  padding-left: 30px;
  color: #ff3b30;
  font-size: 14px;
  text-align: left;
`;

class Input extends Component {
  render() {
    const { input, meta, termsConditions, competitionId, checked, ...props } = this.props;
    return (
      <CustomCheckBox>
        <label>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <input type="checkbox" {...input} {...props} />
          <div className="box">
            <IoMdCheckmark />
          </div>
          {termsConditions && (
            <div className="terms">
              (Mandatory) I accept the
              <Link target="_blank" to={`/privacy-policy?competitionId=${competitionId}`}>
                Terms and Conditions, Privacy Policy
              </Link>
              and I consent to receive email communication about GSA services.
            </div>
          )}
        </label>
        {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
      </CustomCheckBox>
    );
  }
}

Input.propTypes = {
  meta: propTypes.object,
  input: propTypes.object,
  termsConditions: propTypes.bool,
  competitionId: propTypes.string,
  checked: propTypes.bool
};

export default Input;
